<template>
  <b-form>
    <b-tabs>
      <b-tab title="Dados Cadastrais">
        <div class="row">
          <div class="col">
            <b-form-group label="Nome">
              <b-form-input v-model="usuario.nome" required />
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <b-form-group
              v-model="usuario.superUser"
              label="Super usuário ?"
              required
            >
              <b-form-checkbox v-model="usuario.superUser">
                Sim
              </b-form-checkbox>
            </b-form-group>
          </div>
          <div class="col">
            <b-form-group label="Senha">
              <b-form-input v-model="usuario.senha" required> </b-form-input>
            </b-form-group>
          </div>
          <div class="col">
            <b-form-group label="Confirmar Senha">
              <b-form-input v-model="confirmPassword"> </b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-3" v-if="!usuario.superUser">
            <b-form-group label="Tipo">
              <b-form-select
                v-model="usuario.tipo"
                :options="optionsTipo"
                required
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="col-3" v-if="usuario.tipo==='secretaria_conveniado'">
            <b-form-group label="Conveniado">
              <b-form-input
                @focus="showConveniadoFilter=true"
                  name="filterConveniado"
                  v-model="filterConveniadoText"
                ></b-form-input>
                <div class="filtered-select" v-if="showConveniadoFilter">
                  <ul>
                    <li v-for="conveniado of filteredConveniados" :key="conveniado._id" @click="selectConveniado(conveniado)">{{conveniado.nome}}</li>
                  </ul>
                </div>
            </b-form-group>
          </div>
        </div>
      </b-tab>
      <b-tab title="Permissões" v-if="false">
        <div class="row">
          <div class="col">
            <b-form-group>
              <b-form-select
                v-model="usuario.bancos"
                :options="optionsBancos"
                required
              ></b-form-select>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b-form-group label="Desktop">
              <b-form-input v-model="usuario.desktop" required></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col">
            <b-form-group v-slot="{ ariaDescribedby }" label="Estoque" required>
              <b-form-checkbox-group
                v-model="usuario.estoque"
                :options="acesso"
                :aria-describedby="ariaDescribedby"
                name="flavour-2a"
                stacked
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
        </div>
      </b-tab>
    </b-tabs>
    <b-button type="submit" variant="primary" @click.prevent.stop="validForm"
      >Salvar</b-button
    >
  </b-form>
</template>

<script>
import alertMixin from '@/src/mixins/alertMixin'
import conveniadoMixin from '@/src/mixins/conveniadoMixin'

export default {
  mixins: [alertMixin, conveniadoMixin],
  props: {
    usuario: {
      type: Object,
      required: true,
    },
    salvar: {
      type: Function,
      required: true,
    },
    editar: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      confirmPassword: '',

      acesso: [
        { value: 'liberado', text: 'liberado' },
        { value: 'cadastra', text: 'Cadastrar' },
        { value: 'altera', text: 'Alterar' },
        { value: 'imprimi', text: 'Imprimir' },
        { value: 'exclui', text: 'Excluir' },
        { value: 'consulta', text: 'Consultar' },
      ],
      optionsBancos: [
        { value: 'banco1', text: 'Banco 1' },
        { value: 'banco2', text: 'Banco 2' },
      ],
      optionsTipo: [
        { value: 'atendente', text: 'Atendente Viva' },
        { value: 'atendente_orcamento', text: 'Atendente Orçamento' },
        { value: 'secretaria_conveniado', text: 'Secretária Conveniado ' },
        { value: 'caixa_financeiro', text: 'Caixa Financeiro' },
        { value: 'gerente', text: 'Gerente' },
        { value: 'gerente_financeiro', text: 'Gerente Financeiro' },
        { value: 'adm_agenda', text: 'Administrador Agenda' },
        { value: 'gerente_administrativo', text: 'Gerente administrativo' },
        { value: 'verificador', text: 'Verificador' },
        { value: 'gestao_cadastro_agenda', text:'Gestor de Cadastro/Agenda'}
      ],
      conveniados: [],
      filteredConveniados: [],
      showConveniadoFilter: false,
      filterConveniadoText: '',
    }
  },
  watch:{
    filterConveniadoText(){
      this.filterConveniado(this.filterConveniadoText)
      this.showConveniadoFilter = true
    },
    'usuario.superUser'(){
      if(this['usuario.superUser'])
        this.usuario.tipo = "adm"
      else
        this.usuario.tipo = ""
    }
  },
  async created() {
    await this.loadAllAttributes()
  },
  methods: {
    selectConveniadoById(conveniadoId){
      let conveniado = this.conveniados[this.conveniados.findIndex(i=>(i._id).toString()==(conveniadoId).toString())]
      this.selectConveniado(conveniado)
    },
    selectConveniado(conveniadoId){
      if(conveniadoId){
        this.usuario.conveniado = conveniadoId._id
        this.filterConveniadoText = conveniadoId.nome
        setTimeout(() => {
          this.showConveniadoFilter = false
        }, 100);
      }
    },
    filterConveniado(filter){
      if(!filter){
        this.filteredConveniados = this.conveniados.slice(0,4)
        return
      }
      
      this.filteredConveniados = this.conveniados.filter(i=>(i.nome.toLowerCase()).includes(filter.toLowerCase())||
      (i.registro?i.registro.toLowerCase():"").includes(filter.toLowerCase())).slice(0,4)
    },
    loadAllAttributes() {
      this.loadConveniadosBySelect().then((conveniados) => {
          this.conveniados = conveniados
          if(this.usuario.conveniado)
            this.selectConveniadoById(this.usuario.conveniado);
          this.filterConveniado()
      })
    },
    validForm() {
      if (this.confirmPassword !== this.usuario.senha) {
        this.errorMessage('Senha Não Confere')
      } else {
        if (this.usuario._id) {
          this.editar(this.usuario)
        } else {
          this.salvar(this.usuario)
        }
      }
    },
  },
}
</script>

<style scoped>
.filtered-select{
  position: absolute;
  background-color: white;
  width: 96%;
  left: 0;
  z-index: 100;
}
.filtered-select ul{
  list-style: none;
  padding-left: 19px;
}
.filtered-select ul li{
  padding-top: 10px;
  padding-left: 10px;
  font-size: 14px;
  border-radius: 2%;
  justify-content: center;
}
.filtered-select ul li:hover{
  background-color: #0088a8;
  color: white;
  transition: 200ms;
}
</style>
